import { Controller } from "@hotwired/stimulus"

// data-controller="onboarding--accept-checkbox"
// targets: checkbox, submit
// action: change->onboarding--accept-checkbox#toggle
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasSubmitTarget || !this.hasCheckboxTarget) return
    this.submitTarget.disabled = !this.checkboxTarget.checked
  }
}
